<template>
    <div class="log-box">
        <xx-table-pro
            ref="table"
            name="table"
            source="local"
            :local-data="renderLogs"
            :columns="columns"
            :pagination="false"
        >
            <template
                slot="comment"
                slot-scope="{row}"
            >
                <div v-if="row.taskComments && row.taskComments.length">
                    <p
                        v-for="(task, index) in row.taskComments"
                        :key="task.id"
                    >
                        <span>{{ index + 1 }}.</span>
                        <span>
                            {{ task.comments.map((item) => item.name).join('-') }}
                        </span>
                        <span v-if="task.remark">：{{ task.remark }}</span>
                        <el-button
                            v-if="task.picUrls && task.picUrls.length"
                            type="text"
                            size="mini"
                            @click="onPreview(task.picUrls)"
                        >
                            查看图片
                        </el-button>
                    </p>
                </div>
                <span v-else>{{ row.comment || '--' }}</span>
            </template>
        </xx-table-pro>
        <div
            v-if="auditLogs.length > limitRow"
            class="align-center"
        >
            <div
                class="unfold-btn"
                @click="isUnfold = !isUnfold"
            >
                {{ isUnfold ? "收起" : "展开查看全部审批意见/驳回理由" }}
                <i :class="isUnfold ? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
            </div>
        </div>
        <!-- 暂时用xx-image提供的图片预览，是否有其他组件替代，或者造一个 -->
        <xx-image
            ref="xxImage"
            style="width: 0; height: 0"
            :src="currentPics[0]"
            :preview-src-list="currentPics"
        />
    </div>
</template>
<script>
export const statusEnum = [
    { label: '已提交', value: 0, class: 'submit' },
    { label: '审核中', value: 10, class: 'current' },
    { label: '已通过', value: 20, class: 'pass' },
    { label: '通过并加签', value: 21, class: 'pass' },
    { label: '已驳回', value: 30, class: 'reject' },
    { label: '已撤销', value: 40, class: 'revoke' },
    { label: '重新提交', value: 50, class: '' },
    { label: '', value: 99, class: 'pending' }, // 待审核
    { label: '异常', value: -1, class: '' },
];

const columns = [
    {
        label: '操作时间',
        prop: 'taskUtime',
        template: {
            tpl: 'datetime',
            format: 'YYYY-MM-DD HH:mm:ss',
        },
    }, {
        label: '节点',
        prop: 'taskName',
    }, {
        label: '操作',
        prop: 'status',
        width: 170,
        template: {
            tpl: 'enum',
            list: statusEnum,
        },
    }, {
        label: '审批/驳回意见',
        prop: 'comment',
    },
];

export default {
    name: 'AuditLog',
    components: {},
    props: {
        applyId: {
            type: String,
            default: '',
        },
        updateTimestamp: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            // 列表结构
            columns,
            // 后端返回数据
            auditLogs: [],
            // 行数限制
            limitRow: 1,
            // 是否展开
            isUnfold: false,
            currentPics: [''], // xx-image src属性必须有值，否则会图片加载失败
        };
    },
    computed: {
        renderLogs() {
            if (!this.isUnfold) return this.auditLogs.slice(0, this.limitRow);
            return this.auditLogs;
        },
    },
    watch: {
        applyId: {
            handler() {
                this.loadData();
            },
            immediate: true,
        },
        updateTimestamp() {
            this.loadData();
        },
    },
    methods: {
        async loadData() {
            if (!this.applyId) return;
            const response = await this.$hPost('/api/vss/shepherd/product/listApplyAuditLog', {
                applyId: this.applyId,
            }).catch((err) => {
                this.$message.error(
                    err.message || err.msg || '获取审批信息失败',
                );
                return null;
            });

            if (response) this.auditLogs = response.items.reverse();
        },
        onPreview(urls) {
            this.currentPics = urls;
            this.$refs.xxImage.clickHandler();
        },
    },
};
</script>
<style scoped lang="scss">
.unfold-btn {
    padding: 10px;
    font-size: 14px;
    color: #008547;
    cursor: pointer;
}
.align-center {
    text-align: center;
}
</style>
